export const GET_JMS_DETAILS = "GET_JMS_DETAILS";
export const SUBMIT_JMS_DATA = "SUBMIT_JMS_DATA";
export const GET_JMS_LIST = "GET_JMS_LIST";
